import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { FC } from 'react';
import { useDarkMode, useMediaUp } from '../../../hooks';
import Image from 'next/image';
import { ArchitectureIcon } from '../../../svgs/gpm';

interface GpmArchitectureProps {
  title: string;
  subtitle: string;
  description: string;
  image?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: theme.spacing(10, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(15, 0),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(13.5, 0),
    },
  },
  item: {
    position: 'relative',
  },
  gpmTitle: {
    color: '#116666',
    fontSize: 35,
    lineHeight: '35px',
    fontWeight: 700,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      fontSize: 45,
      lineHeight: '45px',
    },
  },
  subtitle: {
    color: (isDarkMode) => (isDarkMode ? theme.palette.common.white : '#0A1524'),
    fontSize: 15,
    fontWeight: 500,
    maxWidth: '100%',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      fontSize: 20,
      maxWidth: 432,
    },
  },
  description: {
    color: (isDarkMode) => (isDarkMode ? theme.palette.common.white : '#0A1524'),
    fontSize: 11,
    fontWeight: 400,
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      fontSize: 12,
      maxWidth: 347,
    },
  },
}));

const GpmArchitecture: FC<GpmArchitectureProps> = (props) => {
  const { title, subtitle, description, image } = props;
  const { isDarkMode } = useDarkMode();
  const classes = useStyles(isDarkMode);
  const mediaUp = useMediaUp('md');

  return (
    <Container maxWidth={false} fixed>
      <Grid className={classes.content} justifyContent="space-between" alignItems={'center'} container spacing={mediaUp ? 8 : 4}>
        <Grid className={classes.item} md={6} xs={12} item>
          {mediaUp && (
            <Box position={'absolute'} right={-10} top={'-35%'}>
              <ArchitectureIcon />
            </Box>
          )}
          <Typography className={classes.gpmTitle}>{title}</Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
          <Typography className={classes.description}>{description}</Typography>
        </Grid>
        <Grid md={6} xs={12} item>
          <Box mt={mediaUp ? -10 : 0}>
            <Image src={image} height={381} width={583} />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default GpmArchitecture;
